module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gray-back",
    staticStyle: {
      "padding": ".2rem 0 1rem 0"
    }
  }, [(_vm.formData.jianshe.refuse_note && _vm.formData.jianshe.status == 3) ? _c('van-notice-bar', {
    attrs: {
      "text": '申请被拒绝！ 理由：' + _vm.formData.jianshe.refuse_note
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.showInfo) ? _c('van-form', {
    on: {
      "submit": _vm.onSubmit,
      "failed": _vm.onFailed
    }
  }, [_c('van-cell-group', [_c('van-cell', {
    attrs: {
      "is-link": "",
      "clickable": "",
      "value": "点击下载",
      "autosize": "",
      "input-align": "right",
      "title": "俱乐部建设相关文件下载"
    },
    on: {
      "click": function($event) {
        return _vm.download()
      }
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "验收表扫描件"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('FileUploader', {
    attrs: {
      "uploadText": "打包文件",
      "fileList": _vm.formData.yanshoubiao_pic,
      "limit": 1,
      "accept": ".zip,.rar",
      "name": 'yanshoubiao_pic'
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "operate-desc-left",
    on: {
      "click": _vm.download
    }
  }, [_vm._v("点击下载验收表")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: (_vm.formData.pc_url),
      expression: "formData.pc_url",
      arg: "copy"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:success",
      value: (_vm.onCopy),
      expression: "onCopy",
      arg: "success"
    }],
    staticStyle: {
      "padding": "10px 15px",
      "margin-top": "20px",
      "background": "#fffbe8",
      "color": "#333",
      "text-align": "center"
    }
  }, [_vm._v("\n          如果您手机不方便上传压缩包，还可以复制以下网址用电脑浏览器上传\n          "), _c('br'), _vm._v("\n          " + _vm._s(_vm.formData.pc_url) + "\n          "), _c('br'), _vm._v("\n          点击复制\n        ")]), _vm._v(" "), _c('van-field', {
    attrs: {
      "readonly": "",
      "clickable": "",
      "name": "area",
      "value": _vm.formData.county ? _vm.formData.province + '/' + _vm.formData.city + '/' + _vm.formData.county : '',
      "input-align": "right",
      "label": "地区选择",
      "placeholder": "点击选择省市区"
    },
    on: {
      "click": function($event) {
        _vm.showArea = true
      }
    }
  }), _vm._v(" "), _c('van-popup', {
    attrs: {
      "position": "bottom"
    },
    model: {
      value: (_vm.showArea),
      callback: function($$v) {
        _vm.showArea = $$v
      },
      expression: "showArea"
    }
  }, [_c('van-area', {
    attrs: {
      "area-list": _vm.areaList,
      "value": _vm.formData.area
    },
    on: {
      "confirm": _vm.onAreaConfirm,
      "cancel": function($event) {
        _vm.showArea = false
      }
    }
  })], 1), _vm._v(" "), _c('van-field', {
    attrs: {
      "rules": [{
        required: true,
        message: '不能为空'
      }],
      "label": "俱乐部名称",
      "input-align": "right",
      "error-message-align": "right",
      "clearable": "",
      "placeholder": "请输入俱乐部名称"
    },
    model: {
      value: (_vm.formData.danwei),
      callback: function($$v) {
        _vm.$set(_vm.formData, "danwei", $$v)
      },
      expression: "formData.danwei"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "name": "radio",
      "label": "申报等级",
      "input-align": "right"
    },
    scopedSlots: _vm._u([{
      key: "input",
      fn: function() {
        return [_c('van-radio-group', {
          model: {
            value: (_vm.formData.bgrade),
            callback: function($$v) {
              _vm.$set(_vm.formData, "bgrade", $$v)
            },
            expression: "formData.bgrade"
          }
        }, [_c('van-radio', {
          attrs: {
            "checked-color": "#ffb01b",
            "name": "二星"
          }
        }, [_vm._v("二星")]), _vm._v(" "), _c('van-radio', {
          attrs: {
            "checked-color": "#ffb01b",
            "name": "三星"
          }
        }, [_vm._v("三星")]), _vm._v(" "), _c('van-radio', {
          attrs: {
            "checked-color": "#ffb01b",
            "name": "四星"
          }
        }, [_vm._v("四星")]), _vm._v(" "), _c('van-radio', {
          attrs: {
            "checked-color": "#ffb01b",
            "name": "五星"
          }
        }, [_vm._v("五星")])], 1)]
      },
      proxy: true
    }], null, false, 1918662455)
  }), _vm._v(" "), _c('van-notice-bar', {
    attrs: {
      "text": "如有问题请私信工作人员"
    }
  }), _vm._v(" "), (false) ? _c('div', [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": "https://ccago.oss-cn-hangzhou.aliyuncs.com/editor/20231119/user-0/20231119/aacdafd4e06f51da3f4157299780a0dd.jpg"
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "30px",
      "text-align": "center"
    }
  }, [_c('van-button', {
    staticStyle: {
      "margin": "0 auto"
    },
    attrs: {
      "size": "normal",
      "round": ""
    },
    on: {
      "click": function($event) {
        return _vm.goWenjuan()
      }
    }
  }, [_vm._v("俱乐部情况调查问卷\n      ")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "savebtn"
  }, [_c('van-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.formData.jindu == 6),
      expression: "formData.jindu==6"
    }],
    staticStyle: {
      "width": "3rem"
    },
    attrs: {
      "disabled": true,
      "color": "linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)",
      "size": "normal",
      "round": ""
    }
  }, [_vm._v("\n          已授牌\n        ")]), _vm._v(" "), _c('van-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.formData.jindu != 6 && _vm.formData.grade != '二星'),
      expression: "formData.jindu!=6 && formData.grade!='二星'"
    }],
    staticStyle: {
      "width": "3rem"
    },
    attrs: {
      "color": "linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)",
      "size": "normal",
      "round": "",
      "disabled": _vm.saveLoading,
      "loading": _vm.saveLoading,
      "loading-text": "提交中..."
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("\n          提交申请\n        ")])], 1)], 1) : _c('div', [_c('div', {
    staticStyle: {
      "padding": "0 .2rem"
    }
  }, [_c('ul', {
    staticClass: "step-two-box"
  }, [_c('li', [_vm._v("提交申报信息成功！")]), _vm._v(" "), _c('li', [_vm._v("工作人员会在三个工作日内与您联系。")]), _vm._v(" "), _c('li', [_vm._v("审批通过后，点击 “刷新”按钮，方可")]), _vm._v(" "), _c('li', [_vm._v("进行下一步操作")])])]), _vm._v(" "), _c('div', {
    staticClass: "savebtn"
  }, [_c('van-button', {
    staticStyle: {
      "width": "3rem"
    },
    attrs: {
      "color": "linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)",
      "size": "normal",
      "round": ""
    }
  }, [_vm._v("\n          刷新\n        ")])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7b6a615a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/club/ClubHighApplyNew.vue
// module id = 2491
// module chunks = 0